import React from 'react';
import { useMutation } from '@apollo/client';
import TrackerAddMealMutation from './TrackerAddMealMutation';
import TrackerQuery from '../Fetch/TrackerQuery';
import { formatIsoDate } from '../../../Helpers/dateFormatter';

interface ITrackerAddMealConnectorApolloProps {
  children: ({ addMeal }: { addMeal: (mealId: number) => Promise<any> }) => React.ReactElement;
  post: any;
}

const TrackerAddMealConnectorApollo: React.FC<ITrackerAddMealConnectorApolloProps> = ({
  children,
  post,
}) => {
  const [addMealMutation] = useMutation(TrackerAddMealMutation);

  const addMeal = async (input: any) => {
    const date = formatIsoDate(new Date(input.dateTime));

    const response = await addMealMutation({
      variables: { input },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TrackerQuery,
          variables: {
            date,
          },
        },
      ],
    });

    if (post) {
      post('reload');
    }

    return response.data.dailyTracker.addDietMeal;
  };
  return children({ addMeal });
};

export default TrackerAddMealConnectorApollo;
